import { InputNumberLocalized } from '@components'

import { Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import type { ReviewEntriesAmountRangeFilter } from '../../../../types/reviewEntriesFilters'
import { BodyContainer, RangeField, RangeFieldsRow } from '../../styles'

interface AmountRangeFilterBodyProps {
  range: ReviewEntriesAmountRangeFilter | undefined
  onChange: (range: ReviewEntriesAmountRangeFilter | undefined) => void
}

export const AmountRangeFilterBody = ({ range, onChange }: AmountRangeFilterBodyProps): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const currencyId = organization?.baseCurrencyId ?? 'EUR'

  const handleFromChange = useCallback(
    (value: number) => {
      onChange({
        from: Number.isFinite(value) ? value : undefined,
        to: range?.to,
      })
    },
    [onChange, range?.to],
  )

  const handleToChange = useCallback(
    (value: number) => {
      onChange({
        from: range?.from,
        to: Number.isFinite(value) ? value : undefined,
      })
    },
    [onChange, range?.from],
  )

  return (
    <BodyContainer>
      <RangeFieldsRow>
        <RangeField>
          <Text variant="bodyMD" weight="medium">
            {t('review_entries.filters.amount.from')}
          </Text>
          <InputNumberLocalized
            key={`from-${range?.from === undefined}`}
            autoFocus
            isFallbackToZero={false}
            min={0}
            onChange={handleFromChange}
            placeholder="0"
            size="sm"
            suffix={currencyId}
            value={range?.from}
          />
        </RangeField>
        <RangeField>
          <Text variant="bodyMD" weight="medium">
            {t('review_entries.filters.amount.to')}
          </Text>
          <InputNumberLocalized
            key={`to-${range?.to === undefined}`}
            isFallbackToZero={false}
            min={0}
            onChange={handleToChange}
            placeholder="1200"
            size="sm"
            suffix={currencyId}
            value={range?.to}
          />
        </RangeField>
      </RangeFieldsRow>
    </BodyContainer>
  )
}
